import { gql } from '@apollo/client';

export const GET_ORDER = gql`
  query getOrderData($accountId: ID!, $salesOrderNumber: ID!) {
    getAccount(accountId: $accountId) {
      accountId
      getOrder(salesOrderNumber: $salesOrderNumber) {
        salesOrderNumber
        fiscalOrderDate
        orderValue
        currencyCode
        orderStatus
        module
        orderType
        currencyCode
        shippingInfo {
          accountName
          address {
            address1
            address2
            city
            state
            province
            zipcode
            country
          }
          packingInstructions
          shipToContactName
          requestedShipDate
          shipCompleteDate
        }
        billingInfo {
          accountName
          orderedByContactName
          purchaseOrderNumber
          address {
            address1
            address2
            city
            state
            province
            zipcode
            country
          }
        }
        lines {
          lineId
          lineNumber
          displayLineNumber
          fulfillmentLineId
          splitFromFulfillmentLineId
          isRootItem
          isWarranty
          warrantyForDisplayLineNumber
          isPackage
          isPackageBom
          bomForDisplayLineNumber
          sourceLineNumber
          parentLineId
          rootParentLineId
          componentCovered
          serviceDuration
          serviceDurationPeriod
          isLineParent
          lineStatus
          partNumber
          partDescription
          partLongDescription
          totalOrderedQty
          totalShippedQty
          totalCanceledQty
          lineOrderedQty
          lineShippedQty
          unitSellPrice
          extendedSellPrice
          shipmentStatus
          actualShipDate
          scheduledShipDate
          shippingMethod
          freightCarrier
          trackingNumbers {
            trackingNumber
            trackingURL
          }
          waybillNumber
          shipToName
          serialNumbers
          unitData {
            fsan
            macAddress
            serialNumber
          }
        }
      }
    }
  }
`;

export const SEARCH_ORDERS = gql`
  query searchOrders(
    $accountId: ID
    $searchTerm: String
    $searchType: OrderSearchType!
    $orderDateStart: AWSDate
    $orderDateEnd: AWSDate
  ) {
    getAccount(accountId: $accountId) {
      accountId
      searchOrders(
        input: {
          searchTerm: $searchTerm
          searchType: $searchType
          orderDateStart: $orderDateStart
          orderDateEnd: $orderDateEnd
        }
      ) {
        purchaseOrderNumber
        salesOrderNumber
        orderedBy
        fiscalOrderDate
        orderStatus
        orderTotal
        currencyCode
        orderType
        billToOracleId
        projectId
      }
    }
  }
`;
